import { Place } from '@mui/icons-material';
import { Box } from '@mui/material';
import { useLocationsMapIsGrayOut } from '../locations-map-mapbox.hooks';
import { Marker } from 'react-map-gl/mapbox';
import { useSelector } from 'react-redux';
import { scroller } from 'react-scroll';
import { selectMapPin } from 'redux/config/config.selectors';

const pinStyle = (selectedStore, store, isGrayOut) => ({
  cursor: 'pointer',
  '&:hover':
    selectedStore?.storeId !== store.storeId
      ? {
          transform: 'scale(1.1)',
          transformOrigin: 'bottom center',
          transition: 'transform 0.1s ease-in-out',
        }
      : {},
  ...(selectedStore?.storeId === store.storeId
    ? {
        transform: 'scale(1.3)',
        transformOrigin: 'bottom center',
        transition: 'transform 0.4s ease-in-out',
      }
    : {}),
  ...(isGrayOut
    ? {
        // filter: 'grayscale(100%)',
        filter: 'contrast(0.5)',
        transform: 'scale(1)',
        transformOrigin: 'bottom center',
        opacity: 0.5,
      }
    : {
        filter: 'contrast(1)',
      }),
});

const LocationMapMarker = ({
  store,
  setSelectedStore,
  selectedStore,
  ...rest
}) => {
  const mapPin = useSelector(selectMapPin);
  const isGrayOut = useLocationsMapIsGrayOut(store);
  const handleClick = () => {
    setSelectedStore(store);
    setTimeout(() => {
      scroller.scrollTo(store.storeId, {
        smooth: true,
        containerId: 'locationsListContainer',
        offset: -5,
      });
    }, 10);
  };

  return (
    <Box component={Marker} {...rest} onClick={handleClick}>
      {
        /* istanbul ignore next */ mapPin ? (
          <Box
            component="img"
            src={mapPin}
            alt=""
            sx={{
              width: 50,
              ...pinStyle(selectedStore, store, isGrayOut),
            }}
            data-testid={
              isGrayOut
                ? 'LocationsMapMarker.PinImage.GrayOut'
                : 'LocationsMapMarker.PinImage'
            }
          />
        ) : (
          <Box
            component={Place}
            sx={{
              fontSize: 42,
              color: 'rgb(51, 204, 238)',
              ...pinStyle(selectedStore, store, isGrayOut),
            }}
            data-testid={
              isGrayOut
                ? 'LocationsMapMarker.Pin.GrayOut'
                : 'LocationsMapMarker.Pin'
            }
          />
        )
      }
    </Box>
  );
};
export default LocationMapMarker;
